import ErrorPageLayout from './ErrorPageLayout'

 
export default ErrorPageLayout
